export const AssayColumns = () => (
  <>
    <h4>Assay columns</h4>
    <p>
      For mzTab-M all <strong>abundance_assay[n]</strong> columns of the summary table are used for fitting the lipid profiles.
      For other tabular data files, <strong>all except the first column</strong> define individual assays and should contain unique names.
    </p>
  </>
)

